import WorkOrderTable from './WorkOrderTable'
export default WorkOrderTable
